import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { CityParkingUserLineResponse, CityParkingUserVehicleListResponse, CityParkingVehicleListResponse, cityParkingVehicleMasterListResponse } from '../../../../../core/models/lineOA.model';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../../../../../core/services/api.service';
import { ToastService } from 'angular-toastify';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { PssLoadingComponent } from "../../../../../tools/template/pss/pss-loading/pss-loading.component";
import { ActionBackOfficeResponse } from '../../../../../core/models/api.model';
import { CityParkingUserVehiclePayload } from '../../../../../core/models/vehicle.model';

@Component({
  selector: 'app-modal-line-oa-member-add-vehicle',
  imports: [
    CommonModule,
    FormsModule,
    PssLoadingComponent
  ],
  templateUrl: './modal-line-oa-member-add-vehicle.component.html',
  styleUrl: './modal-line-oa-member-add-vehicle.component.css' // แก้ styleUrl เป็น styleUrls ในบางเวอร์ชั่น
})
export class ModalLineOaMemberAddVehicleComponent implements OnInit, OnChanges {

  @Input() licenseOld: CityParkingUserVehicleListResponse | null = null;
  @Input() member: CityParkingUserLineResponse | null = null;
  @Input() eventForm: string = 'create';

  @Output() close = new EventEmitter<boolean>();

  // Alert
  isLoading: boolean = false;

  // Default
  vehicleOptionsForm: cityParkingVehicleMasterListResponse = {
    cityParkingProvinceListResponses: [],
    cityParkingVehicleTypeListResponses: []
  }
  vehicleStatus: any[] = [
    { id: 1, name: 'กำลังจอด' },
    { id: 2, name: 'ไม่ได้จอดอยู่' },
  ];

  // Values
  id: number = 0;
  provinceId: number = 0;
  plateNumber: string = '';
  vehicleTypeId: number = 0;
  cpUserId: number = 0;
  userId: number = 0;

  provinceOld: string = '';
  vehicleTypeOld: string = '';

  // Validation Errors Object
  errors: any = {};

  // Dropdown States
  isProvinceDropdownOpen: boolean = false;
  isVehicleTypeDropdownOpen: boolean = false;
  searchTermProvince: string = '';
  searchTermVehicleType: string = '';

  // Payload
  newVehicle: CityParkingUserVehiclePayload = this.getEmptyPayload();

  constructor(
    private apiService: ApiService,
    private http: HttpClient,
    private toast: ToastService,
    private cookieService: CookieService
  ) { }

  ngOnInit(): void {
    this.isLoading = true;
    // ดึง Option ต่างๆ
    this.getApiVehicleMaster();

    const userIdFromSession = sessionStorage.getItem('user_id');
    this.userId = parseInt(this.cookieService.get('user_id')) || (userIdFromSession ? JSON.parse(userIdFromSession) : 0);

    switch (this.eventForm) {
      case 'edit':
        if (!this.licenseOld) return;
        this.setValueAddVehicleFormOld(this.licenseOld);
        break;
      default:
        break;
    }
  }

  // ใช้ OnChanges เพื่อ update cpUserId ทันทีที่ input member เข้ามา
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['member'] && this.member) {
      this.cpUserId = this.member.id;
    }
  }

  // ----------------------------------------- Functions -----------------------------------------

  closeAddVehicleModal() {
    this.resetValues();
    this.close.emit(false);
  }




  /*--------------- Get | Set  ---------------*/
  setValueAddVehicleForm() {
    this.newVehicle = {
      id: 0,
      provinceId: this.provinceId,
      oldProvince: 0,
      plateNumber: this.plateNumber,
      oldlicense: '',
      vehicleTypeId: this.vehicleTypeId,
      vehicleStatusId: 2,
      oldVehicleType: 0,
      cpUserId: this.cpUserId, // ใช้ตัวแปรที่รับมาจาก ngOnChanges
      userId: this.userId
    };
    // console.log("Form : ", this.provinceId
    //   , this.plateNumber
    //   , this.vehicleTypeId
    //   , this.cpUserId
    //   , this.userId
    //   , "New Vehicle : ", this.newVehicle);
  }
  setValueAddVehicleFormOld(licenseOld: CityParkingUserVehicleListResponse) {
    this.newVehicle = {
      id: licenseOld.id,
      provinceId: licenseOld.provinceId,
      oldProvince: licenseOld.provinceId,
      plateNumber: licenseOld.plateNumber,
      oldlicense: licenseOld.plateNumber,
      vehicleTypeId: licenseOld.vehicleTypeId,
      vehicleStatusId: 2,
      oldVehicleType: licenseOld.vehicleTypeId,
      cpUserId: this.cpUserId, // ใช้ตัวแปรที่รับมาจาก ngOnChanges
      userId: this.userId
    };
    this.plateNumber = licenseOld.plateNumber;
    this.provinceId = licenseOld.provinceId;
    this.vehicleTypeId = licenseOld.vehicleTypeId;

    this.licenseOld = licenseOld;
    this.provinceOld = licenseOld.provinceName;
    this.vehicleTypeOld = licenseOld.vehicleTypeName;

    // console.log("Form : "
    //   , this.provinceId
    //   , this.plateNumber
    //   , this.vehicleTypeId
    //   , this.cpUserId
    //   , this.userId
    //   , "New Vehicle : ", this.newVehicle);
  }
  setValueAddVehicleFormOldPayload() {
    this.newVehicle.provinceId = this.provinceId;
    this.newVehicle.plateNumber = this.plateNumber;
    this.newVehicle.vehicleTypeId = this.vehicleTypeId;
    this.newVehicle.cpUserId = this.cpUserId;
    this.newVehicle.userId = this.userId;

    // console.log("Form : "
    //   , this.provinceId
    //   , this.plateNumber
    //   , this.vehicleTypeId
    //   , this.cpUserId
    //   , this.userId
    //   , "New Vehicle : ", this.newVehicle);
  }
  getEmptyPayload(): CityParkingUserVehiclePayload {
    return {
      id: 0,
      provinceId: 0,
      oldProvince: 0,
      plateNumber: '',
      oldlicense: '',
      vehicleTypeId: 0,
      oldVehicleType: 0,
      vehicleStatusId: 0,
      cpUserId: 0,
      userId: 0
    };
  }
  resetValues() {
    this.newVehicle = this.getEmptyPayload();
    this.id = 0;
    this.provinceId = 0;
    this.plateNumber = '';
    this.vehicleTypeId = 0;
    this.cpUserId = this.member?.id || 0; // Reset แต่ยังคงค่า Member ID ไว้
    this.eventForm = 'create';
    this.errors = {}; // Clear errors
    this.isProvinceDropdownOpen = false;
    this.isVehicleTypeDropdownOpen = false;
    this.searchTermProvince = '';
    this.searchTermVehicleType = '';
  }

  /* -------------------------- Dropdown Helpers -------------------------- */
  toggleProvinceDropdown() {
    this.isProvinceDropdownOpen = !this.isProvinceDropdownOpen;
    if (this.isProvinceDropdownOpen) {
      this.isVehicleTypeDropdownOpen = false;
      this.searchTermProvince = '';
    }
  }

  toggleVehicleTypeDropdown() {
    this.isVehicleTypeDropdownOpen = !this.isVehicleTypeDropdownOpen;
    if (this.isVehicleTypeDropdownOpen) {
      this.isProvinceDropdownOpen = false;
      this.searchTermVehicleType = '';
    }
  }

  selectProvince(province: any) {
    this.provinceId = province.id;
    this.isProvinceDropdownOpen = false;
    this.clearError('provinceId');
  }

  selectVehicleType(type: any) {
    this.vehicleTypeId = type.id;
    this.isVehicleTypeDropdownOpen = false;
    this.clearError('vehicleTypeId');
  }

  get filteredProvinces() {
    if (!this.searchTermProvince) return this.vehicleOptionsForm.cityParkingProvinceListResponses;
    return this.vehicleOptionsForm.cityParkingProvinceListResponses.filter(p => 
      p.name.toLowerCase().includes(this.searchTermProvince.toLowerCase())
    );
  }

  get filteredVehicleTypes() {
    if (!this.searchTermVehicleType) return this.vehicleOptionsForm.cityParkingVehicleTypeListResponses;
    return this.vehicleOptionsForm.cityParkingVehicleTypeListResponses.filter(t => 
      t.name.toLowerCase().includes(this.searchTermVehicleType.toLowerCase())
    );
  }

  get selectedProvinceName() {
    const selected = this.vehicleOptionsForm.cityParkingProvinceListResponses.find(p => p.id == this.provinceId);
    return selected ? selected.name : 'เลือกจังหวัด';
  }

  get selectedVehicleTypeName() {
    const selected = this.vehicleOptionsForm.cityParkingVehicleTypeListResponses.find(t => t.id == this.vehicleTypeId);
    return selected ? selected.name : 'เลือกประเภทรถ';
  }

  /* --------------------------------------- Function -------------------------------------- */
  confirmAddVehicle() {
    if (this.validateForm()) {
      this.setValueAddVehicleFormOldPayload();
      this.sentApiUpdateAddVehicle();
    }
  }

  // ----------- Validate ----------
  onPlateNumberChange(value: string) {
    if (value) {
      const cleaned = value.replace(/[^a-zA-Z0-9ก-ฮ]/g, '');
      this.plateNumber = cleaned;
      this.clearError('plateNumber');
    }
  }

  clearError(field: string) {
    if (this.errors[field]) {
      delete this.errors[field];
    }
  }

  validateForm(): boolean {
    this.errors = {};
    let isValid = true;

    if (!this.plateNumber) {
      this.errors['plateNumber'] = 'กรุณากรอกเลขทะเบียน';
      isValid = false;
    } else if (this.plateNumber.length < 2) {
      this.errors['plateNumber'] = 'เลขทะเบียนสั้นเกินไป';
      isValid = false;
    }

    if (!this.provinceId || this.provinceId === 0) {
      this.errors['provinceId'] = 'กรุณาเลือกจังหวัด';
      isValid = false;
    }

    if (!this.vehicleTypeId || this.vehicleTypeId === 0) {
      this.errors['vehicleTypeId'] = 'กรุณาเลือกประเภทรถ';
      isValid = false;
    }

    if (!this.cpUserId || this.cpUserId === 0) {
      // กรณีนี้ User แก้ไขไม่ได้ แต่แจ้งเตือน System Error
      this.toast.error('ไม่พบข้อมูลสมาชิก (System Error: cpUserId missing)');
      isValid = false;
    }

    if (!this.userId || this.userId === 0) {
      this.toast.error('ไม่พบข้อมูลผู้ทำรายการ (System Error: userId missing)');
      isValid = false;
    }

    return isValid;
  }

  /* ----------------------------------------- API ----------------------------------------- */
  getApiVehicleMaster() {
    this.apiService.getVehicleMaster().subscribe({
      next: (response: cityParkingVehicleMasterListResponse) => {
        this.isLoading = false;
        if (response) {
          //console.log("Master Data : ", response);
          this.vehicleOptionsForm = response;
        } else {
          this.toast.error('ไม่พบข้อมูล Master Data');
        }
      },
      error: (error) => {
        this.isLoading = false;
        console.error('API error:', error);
      },
    })
  }

  sentApiUpdateAddVehicle() {
    this.apiService.sentManageCityparkingVehicle(this.newVehicle).subscribe({
      next: (response: ActionBackOfficeResponse) => {
        this.isLoading = false;
        console.log("Response Add Vehicle : ", response);
        if (response.isSuccess) { // เช็ค Code ตามหลังบ้าน (422 ปกติคือ Error แต่ในที่นี้อาจจะเป็น Success ของระบบคุณ?)
          // แนะนำให้เช็ค: ปกติ 200/201 คือ Success, 422 คือ Unprocessable Entity
          // แต่ถ้า API คุณส่ง 422 มาเป็น Success case ก็ใช้ตามเดิมครับ
          this.toast.success(response.message);
          this.closeAddVehicleModal();
        } else {
          this.toast.error(response.message || 'เกิดข้อผิดพลาดในการบันทึก');
        }
      },
      error: (error) => {
        this.isLoading = false;
        console.error('API error:', error);
        this.toast.error('เกิดข้อผิดพลาดในการเชื่อมต่อเซิร์ฟเวอร์');
      },
    })
  }


}